import { IMap, WithId } from '@skippay/core/@types/common';
import { Country } from '@skippay/core/@types/country';

import {
	CLEAR_USER_DATA,
	ClearUserDataAction,
	SET_BANNER,
	SET_BANNERS,
	SET_CONFIG,
	SET_LAST_UPDATE_TIMESTAMP,
	SET_MODAL,
	SET_MODALS,
	SET_REQUEST,
	SET_REQUESTS,
	SET_USER_COUNTRY,
	SetBannerAction,
	SetBannersAction,
	SetConfigAction,
	SetLastUpdateTimestampAction,
	SetModalAction,
	SetModalsAction,
	SetRequestAction,
	SetRequestsAction,
	SetUserCountryAction,
} from './actions';
import { Banner, Config, Modal, Request } from './types';
import { CLEAR_STORE, ClearStoreAction } from '../shared/actions';

type ActionType =
	| SetLastUpdateTimestampAction
	| SetBannersAction
	| SetBannerAction
	| SetRequestsAction
	| SetRequestAction
	| SetConfigAction
	| SetModalAction
	| SetModalsAction
	| SetUserCountryAction
	| ClearUserDataAction
	| ClearStoreAction;

export interface UserState {
	lastUpdateTimestamp?: number;
	banners?: IMap<Banner>;
	requests?: IMap<WithId<Request>>;
	config?: Config;
	modals?: IMap<WithId<Modal>>;
	country?: Country;
}

const initialState: UserState = {};

function userReducer(state: UserState = initialState, action: ActionType): UserState {
	switch (action.type) {
		case SET_LAST_UPDATE_TIMESTAMP:
			return {
				...state,
				lastUpdateTimestamp: action.lastUpdateTimestamp,
			};

		case SET_BANNER:
			return {
				...state,
				banners: {
					...state.banners,
					[action.banner.id]: action.banner,
				},
				lastUpdateTimestamp: Date.now(),
			};

		case SET_BANNERS:
			return {
				...state,
				banners: action.banners,
				lastUpdateTimestamp: Date.now(),
			};

		case SET_REQUEST:
			return {
				...state,
				requests: {
					...state.requests,
					[action.request.id]: action.request,
				},
				lastUpdateTimestamp: Date.now(),
			};

		case SET_REQUESTS:
			return {
				...state,
				requests: action.requests,
				lastUpdateTimestamp: Date.now(),
			};

		case SET_CONFIG:
			return {
				...state,
				config: action.config,
				lastUpdateTimestamp: Date.now(),
			};

		case SET_MODAL:
			return {
				...state,
				modals: {
					...state.modals,
					[action.modal.id]: action.modal,
				},
				lastUpdateTimestamp: Date.now(),
			};

		case SET_MODALS:
			return {
				...state,
				modals: action.modals,
				lastUpdateTimestamp: Date.now(),
			};

		case SET_USER_COUNTRY:
			return {
				...state,
				country: action.country,
			};

		case CLEAR_USER_DATA:
			return { country: state.country };

		case CLEAR_STORE:
			return initialState;

		default:
			return state;
	}
}

export default userReducer;
